module.exports = __webpack_public_path__ + "static/assets/a05bbf6359407ad7950e115edab178d9.mp3";